import React from 'react'

import { AIGeneratedGradient } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf,
  shape,
  string,
  bool,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import AiCard from './AiCard'
import CategoryColumn from './CategoryColumn'

function HomeSearchDropdown({
  columns = EMPTY_ARRAY,
  aiCards = EMPTY_ARRAY,
  aiSectionTitle = '',
  query = '',
}) {
  return (
    <div
      className="home-search-dropdown"
      id="home-search-dropdown"
      role="region"
      aria-label="Search suggestions"
    >
      <div className="home-search-dropdown__columns">
        {columns.map((column) => (
          <CategoryColumn
            key={column.key}
            columnKey={column.key}
            title={column.title}
            searchLabel={column.searchLabel}
            searchPath={column.searchPath}
            browsePath={column.browsePath}
            printReady={column.printReady}
            items={column.items}
            query={query}
          />
        ))}
      </div>

      <div className="home-search-dropdown__ai">
        <div className="home-search-dropdown__ai-header">
          <AIGeneratedGradient className="home-search-dropdown__ai-header-icon" aria-hidden="true" />
          <span className="home-search-dropdown__ai-header-title cgt-caption-semibold">{aiSectionTitle}</span>
        </div>
        <div className="home-search-dropdown__ai-cards">
          {aiCards.map((card) => (
            <AiCard
              key={card.mode}
              mode={card.mode}
              title={card.title}
              description={card.description}
              query={query}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

HomeSearchDropdown.propTypes = {
  columns: arrayOf(
    shape({
      key: string.isRequired,
      title: string.isRequired,
      searchLabel: string.isRequired,
      searchPath: string.isRequired,
      browsePath: string.isRequired,
      printReady: bool,
      items: arrayOf(shape({ label: string, href: string, count: string })),
    })
  ),
  aiCards: arrayOf(
    shape({
      mode: string.isRequired,
      title: string.isRequired,
      description: string.isRequired,
    })
  ),
  aiSectionTitle: string,
  query: string,
}

export default HomeSearchDropdown
